export enum NotificationLevel
{
    System,
    Critical,
    Error,
    Warning,
    Information
}